export default function createFormGroupShape(PropTypes) {
    return PropTypes.shape({
        uniqueName: PropTypes.any,
        parent: PropTypes.any,
        collection: PropTypes.any,
    });
}
